// extracted by mini-css-extract-plugin
export default {"show_total_text":"custom-table_show_total_text__D4azr"};